
import { SiriusBaseComponent } from 'sirius-framework';
import { CommonService } from '../../shared/service/shared.service';
import { SiteLanguageService } from '../../shared/service/site-language.service';
import { DocumentPopupModel2 } from './documentPopup2.model';
import { Input, Output, EventEmitter, Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

declare const $: any;

/** String resource — boşsa Türkçe varsayılan */
const DOCUMENT_POPUP2_KEYS = {
    btnTamam: 'yediEminDocumentPopup2BtnTamam',
    defaultTitle: 'yediEminDocumentPopup2DefaultTitle',
};

const DOCUMENT_POPUP2_DEFAULT_BTN = 'Tamam';
const DOCUMENT_POPUP2_DEFAULT_TITLE = 'Belge';

@Component({
    selector: 'document-popup2',
    templateUrl: './documentPopup2.component.html',
    styleUrls: ['./documentPopup2.component.css']
})

export class DocumentPopupComponent2 extends SiriusBaseComponent<DocumentPopupModel2> implements OnDestroy {
    @Input() opened: boolean = false;
    @Input() visibleCancelBtn: boolean = true; 
    private _docList: Array<string>;
    public documentID: string ;
    @Input() set documentList(value: Array<string>) {
        this._docList = value;
        setTimeout(() => {
            $('#backBtnControlC').trigger("click");
        }, 200);
    }
    @Output() onClose = new EventEmitter();
    @Output() onCancel = new EventEmitter();
    @Output() onScrollEnd = new EventEmitter();
    @Output() onOverlayClicked = new EventEmitter();

    isScrollEnd: boolean = false; 
    defaultDocumentTitle = 'Belge';
    @Input() title: string = '';
    btnTamam = 'Tamam';
    scrollTop: any;
    clientHeight: any;
    scrollHeight: any;
    isFirstCall: boolean = true;

    private langSub: Subscription;

    get documentList(): Array<string> {
        return this._docList;

    }

    constructor(
        private commonService: CommonService,
        private siteLanguageService: SiteLanguageService,
    ) {
        super();
        this.langSub = this.siteLanguageService.languageCode$.subscribe(() => {
            this.loadDocumentPopup2ResourceStrings();
        });
    }

    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
    }

    onDocLoad() {
        $('#backBtnControlC').trigger("click"); 
    }

    OnInit() {
        $('html').addClass('dont-move-back');
    }

    private loadDocumentPopup2ResourceStrings(): void {
        const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);
        this.btnTamam = r(DOCUMENT_POPUP2_KEYS.btnTamam, DOCUMENT_POPUP2_DEFAULT_BTN);
        this.defaultDocumentTitle = r(DOCUMENT_POPUP2_KEYS.defaultTitle, DOCUMENT_POPUP2_DEFAULT_TITLE);
    }

    public close(e: any) {
        this.onClose.emit(e);
        $('html').removeClass('dont-move-back');
    }

    public open() {

    }

  scroll(e: Event) {
        //TODO Volkan: Kontrol et.
      var scrollTop = (e.srcElement as HTMLElement).scrollTop;
      var clientHeight = (e.srcElement as HTMLElement).clientHeight;
      var scrollHeight = (e.srcElement as HTMLElement).scrollHeight;

        //close ve cancel eventenden sonra tekrar çalışıyor.
        if ((scrollTop + clientHeight) >= scrollHeight && this.isFirstCall) {
            this.onScrollEnd.emit(this.title);
            this.isScrollEnd = true;
        }
        this.isFirstCall = true;
    }

    closeDocument() {
        //this.opened = false;
        $('html').removeClass('dont-move-back');
        //this.documentID = null;
        $('#docHolder').scrollTop(0);
        this.isScrollEnd = false;
        this.onClose.emit(this.title);
        this.isFirstCall = false;

    }

    cancelDocument() {
        //this.opened = false;
        $('html').removeClass('dont-move-back');
        //this.documentID = null;
        $('#docHolder').scrollTop(0);
        this.isScrollEnd = false;
        this.onCancel.emit(this.title);
        this.isFirstCall = false;
    }

    clickOverlay(e: Event) {
        this.onOverlayClicked.emit(this.title);
    }
}
